define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'
    
    /**
     * 物体运动状态。
     *
     * @exports EnumPathPlayStatus
     * 
     * @see Path#playStatus
     */
    var EnumPathPlayStatus = {
        /**
         * 停止。
         * @type {Number}
         * @constant
         */
        STOP: 0,

        /**
         * 开始。
         * @type {Number}
         * @constant
         */
        PLAY: 1,

        /**
         * 暂停。
         * @type {Number}
         * @constant
         */
        PAUSE: 2,

        /**
         * 恢复。
         * @type {Number}
         * @constant
         */
        RESUME: 3,

        /**
         * 重新开始。
         * @type {Number}
         * @constant
         */
        RESTART: 4
    }
    freezeObject(EnumPathPlayStatus)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {Number} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumPathPlayStatus) {
            if (EnumPathPlayStatus.hasOwnProperty(key) && EnumPathPlayStatus[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        STOP: 0,
        PLAY: 1,
        PAUSE: 2,
        RESUME: 3,
        RESTART: 4,
        getName: getName
    }
})